/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth-context';
import Landing from './pages/Landing';
import Auth from './pages/Auth';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import AgentTraining from './pages/AgentTraining';
import TermsOfUse from './pages/legal/TermsOfUse';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import CookieNotice from './pages/legal/CookieNotice';
import OutputDisclaimer from './pages/legal/OutputDisclaimer';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/account" element={<Dashboard />} />
          <Route path="/toolkit/agent-training" element={<AgentTraining />} />
          <Route path="/legal/terms-of-use" element={<TermsOfUse />} />
          <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/legal/cookie-notice" element={<CookieNotice />} />
          <Route path="/legal/output-disclaimer" element={<OutputDisclaimer />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
